import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadStatusImportSuccessful, loadStatusImportFailed } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* checkImportStatus(action) {
  try {
    const url = `${BACKEND_URL}/resources/imports/${action.payload.id}`;
    const dataResponse = yield makeRequest(url, {
      with_errors: 1,
    }, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadStatusImportSuccessful(data.data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadStatusImportFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadStatusImportFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
